import PropTypes from "prop-types";

function InputBoolean({
  className,
  register,
  id,
  name,
  setValue,
  required,
  value,
}) {
  return (
    <div className="form-check form-switch">
      <input
        {...register(name)}
        id={id}
        value="1"
        defaultChecked={value === "1"}
        onChange={(event) => {
          setValue(name, event.target.checked ? "1" : null);
        }}
        className={className}
        type="checkbox"
        role="switch"
        required={required}
      />
    </div>
  );
}

InputBoolean.propTypes = {
  className: PropTypes.string,
  control: PropTypes.object,
  id: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.string,
};

export default InputBoolean;
